import { User } from '@auth0/auth0-react';

export interface UserModel extends User {
  id?: string;
  externalName?: string;
  companyName?: string;
  /** Shared cross-platform person id (#194); null until the API's identity key is set. */
  personId?: string | null;
  /** Server-signed Intercom identity JWT (#23); null when the API has no Intercom secret. */
  intercomUserJwt?: string | null;
}

export enum UserDataType {
  DummyData = 1,
  Report = 2,
  GenericConfiguration = 3,
  FileInfo = 4,
  Dummy = 5,
  ShortURL = 6,
  SavedCriteria = 7,
  GridConfiguration = 8,
  FrontendPowerpointExport = 9,
  ElsieAiExport = 10,
  ElsieAiUpload = 11,
  WidgetOptions = 12,
}
